import RegistrationEmailSent from './RegistrationEmailSent';

export default RegistrationEmailSent;
